"use client";

import { createContext, useContext } from "react";

const TripModeContext = createContext(null);

export function TripModeProvider({ children, value }) {
  return (
    <TripModeContext.Provider value={value}>
      {children}
    </TripModeContext.Provider>
  );
}

export function useTripMode() {
  const context = useContext(TripModeContext);
  if (!context) {
    throw new Error("useTripMode must be used within TripModeProvider");
  }
  return context;
}
